
import { EventBus } from '../core/EventBus.js';

export class SocketService {

    retryCount = 0;
    maxRetries = 5;

    constructor(url, token) {

        this.url = url;
        this.token = token;

        if (SocketService.instance) { return SocketService.instance;}

        this.connect();

        SocketService.instance = this;
        return this;
    }

    connect() {

        this.socket = new WebSocket(this.getApiUrl());
        
        this.eventBus = new EventBus();

        this.queue = [];
        this.isOpen = false;

        this.socket.addEventListener('open', () => {
            
            this.isOpen = true;
            this.retryCount = 0;

            this.queue.forEach(msg => this.socket.send(msg));
            this.queue = [];
        });
        this.socket.addEventListener('message', (event) => {

            try {
                const message = JSON.parse(event.data);
                if (message.widgetId) {
                    this.eventBus.emit(message.widgetId, message.payload ?? {});
                }
            } catch (err) {
                console.error('Invalid JSON from Socket', err);
            }
        });

        this.socket.addEventListener('close', () => { this.close(); this.reconnect();});
        this.socket.addEventListener('error', (err) => console.error('Socket error', err));
    }

    send(eventId, payload) {

        const message = JSON.stringify({eventId: eventId, payload: payload});

        if (this.isOpen) {

            if (this.socket.readyState === WebSocket.OPEN) {

                this.socket.send(message);
            }
        } else {

            this.queue.push(message);
        }
    }

    close() {
        
        if (this.socket) {

            this.socket.close();
            this.socket = null;
        }
    }

    reconnect() {

        if (this.retryCount >= this.maxRetries) { return;}

        this.retryCount += 1;
        setTimeout(() => { this.connect();}, 3000);
    }

    getApiUrl() {
        return `${this.url}?token=${this.token}`;
    }
}